import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M8.624 3.001a.7.7 0 0 1 .662.736l-.21 3.928h6.154l.214-4.002a.7.7 0 0 1 1.398.074l-.21 3.928H20.3a.7.7 0 1 1 0 1.4h-3.742l-.312 5.843H20.3a.7.7 0 1 1 0 1.4h-4.129l-.215 4.03a.7.7 0 1 1-1.398-.075l.211-3.955H8.615l-.215 4.03a.7.7 0 1 1-1.398-.075l.211-3.955H3.7a.7.7 0 1 1 0-1.4h3.588L7.6 9.065H3.7a.7.7 0 1 1 0-1.4h3.974l.214-4.002A.7.7 0 0 1 8.624 3Zm.378 6.064-.312 5.843h6.154l.312-5.843H9.002Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
